import axiosInstance from '../../../../utils/axiosInstance';

// =============================================
// VENDORS
// =============================================

export const getVendors = async () => {
  const { data } = await axiosInstance.get('/vendors/');
  return data;
};

export const createVendor = async (vendorData) => {
  const { data } = await axiosInstance.post('/vendors/', vendorData);
  return data;
};

export const updateVendor = async (vendorId, vendorData) => {
  const { data } = await axiosInstance.put(`/vendors/${vendorId}/`, vendorData);
  return data;
};

export const deleteVendor = async (vendorId) => {
  const { data } = await axiosInstance.delete(`/vendors/${vendorId}/`);
  return data;
};

export const bulkCreateVendors = async (vendors) => {
  const { data } = await axiosInstance.post('/vendors/bulk/', { vendors });
  return data;
};

// =============================================
// VENDOR-MERCHANT ASSIGNMENT
// =============================================

export const assignMerchant = async (vendorId, merchantId) => {
  const { data } = await axiosInstance.put(`/vendors/${vendorId}/assign-merchant/`, { merchantId });
  return data;
};

// =============================================
// VENDOR LOGIN DETAILS
// =============================================

export const getVendorLoginDetails = async (vendorId) => {
  const { data } = await axiosInstance.get(`/vendors/${vendorId}/login-details/`);
  return data;
};

// =============================================
// VENDOR USER ASSIGNMENT
// =============================================

export const getVendorUsers = async (vendorId) => {
  const { data } = await axiosInstance.get(`/vendors/${vendorId}/users/`);
  return data;
};

export const addVendorUser = async (vendorId, email) => {
  const { data } = await axiosInstance.post(`/vendors/${vendorId}/users/`, { email });
  return data;
};

export const removeVendorUser = async (vendorId, userId) => {
  const { data } = await axiosInstance.delete(`/vendors/${vendorId}/users/${userId}/`);
  return data;
};

export const getVendorUserLoginDetails = async (vendorId, userId) => {
  const { data } = await axiosInstance.get(`/vendors/${vendorId}/users/${userId}/login-details/`);
  return data;
};
